import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import React from 'react'

import s from './landing.module.css'

/** Interlúdio do líder: foto duotone (ancorada no topo — nunca cortar o rosto). */
export function Interlude() {
  const { t } = useTranslation('landing')

  return (
    <section
      style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'stretch' }}
    >
      <div
        style={{
          flex: 1,
          minWidth: 300,
          minHeight: 520,
          position: 'relative',
        }}
      >
        <Image
          src="/images/landing/lutador-duotone.png"
          alt={t('interlude.photoAlt')}
          fill
          sizes="(max-width: 900px) 100vw, 50vw"
          style={{ objectFit: 'cover', objectPosition: 'top' }}
        />
      </div>
      <div
        style={{
          flex: 1.15,
          minWidth: 320,
          paddingBlock: 110,
          paddingInline: '64px 7vw',
        }}
      >
        <p className={`${s.kick} text-brand`}>
          <span className={s.kbar} />
          {t('interlude.kicker')}
        </p>
        <h2
          className={`${s.d} ${s.h2} text-ink`}
          style={{ margin: '22px 0 0' }}
        >
          {t('interlude.title1')}
          <br />
          <span className={s.outR}>{t('interlude.title2')}</span>
        </h2>
        <p className={s.lead} style={{ marginTop: 16 }}>
          {t('interlude.lead')}
        </p>
      </div>
    </section>
  )
}

/** Faixa vermelha centrada: de todas as equipes, para todas as equipes. */
export function TeamsBanner() {
  const { t } = useTranslation('landing')

  return (
    <section
      className="bg-brand"
      id="equipes"
      style={{ padding: '84px 7vw', textAlign: 'center' }}
    >
      <p
        className={`${s.kick} text-white`}
        style={{ justifyContent: 'center' }}
      >
        <span className={s.kbar} />
        {t('teams.kicker')}
        <span className={s.kbar} />
      </p>
      <h2
        className={`${s.d} text-white`}
        style={{ fontSize: 'clamp(42px,5.8vw,92px)', margin: '20px 0 0' }}
      >
        <span className={s.outW}>{t('teams.title1')}</span>
        <br />
        {t('teams.title2')}
      </h2>
      <p
        className={s.lead}
        style={{
          margin: '20px auto 0',
          maxWidth: 540,
          color: 'rgba(255,255,255,.85)',
        }}
      >
        {t('teams.lead')}
      </p>
    </section>
  )
}

/** Manifesto — fechamento emocional, centrado. */
export function Manifesto() {
  const { t } = useTranslation('landing')

  return (
    <section
      className={s.sec}
      id="manifesto"
      style={{ textAlign: 'center', position: 'relative', overflow: 'hidden' }}
    >
      <p
        className={`${s.kick} text-brand`}
        style={{ justifyContent: 'center' }}
      >
        <span className={s.kbar} />
        {t('manifesto.kicker')}
        <span className={s.kbar} />
      </p>
      <h2
        className={s.d}
        style={{ fontSize: 'clamp(64px,11vw,200px)', marginTop: 18 }}
      >
        <span className={s.outR}>{t('manifesto.titleOutline')}</span>
        <span className="text-brand">{t('manifesto.titleSolid')}</span>
      </h2>
      <p className={s.mlead}>{t('manifesto.lead')}</p>
      <div className={`${s.d} ${s.mline} text-ink`} style={{ marginTop: 44 }}>
        {t('manifesto.line1')}
      </div>
      <div className={`${s.d} ${s.mline} ${s.outR}`}>
        {t('manifesto.line2')}
      </div>
      <div className={`${s.d} ${s.mline} text-ink`} style={{ marginTop: 26 }}>
        {t('manifesto.line3')}
      </div>
      <div className={`${s.d} ${s.mline} text-brand`}>
        {t('manifesto.line4')}
      </div>
    </section>
  )
}
